export default [

    {
        path: '/',
        name: 'root',
        redirect: { name: process.env.VUE_APP_ROTA_INICIAL },
    },

    {
        path: '*',
        redirect: { name: 'erro-404-not-found' },
    },

    {
        path: '/erro',
        component: () => import('@/aplicacao/_erros/_Master'),
        children: [...require('@/aplicacao/_erros/_configuracoes/rotas').default],
    },

    {
        path: '/autenticacao',
        component: () => import('@/aplicacao/_autenticacao/_Master'),
        children: [...require('@/aplicacao/_autenticacao/_configuracoes/rotas').default],
    },

    {
        path: '/senha-expirada',
        name: 'senha-expirada',
        component: () => import('@/aplicacao/SenhaExpirada'),
        meta: { autenticacao: true },
    },

    {
        path: '/comunicados/dashboard',
        name: 'comunicados-dashboard',
        component: () => import('@/aplicacao/modulos/comunicados/Dashboard'),
        meta: { autenticacao: true, permissao: 'ROLE_COMUNICADOS' },
    },

    {
        path: '/',
        component: () => import('@/aplicacao/_Master'),
        children: [...require('@/aplicacao/modulos/_configuracoes/rotas').default],
    },

]
